import { AreaService } from '../../../app/resources/area/area.service';

(function () {
  angular
    .module('specsguardApp')
    .controller('sgAreaStateClusterTableCtrl', sgAreaStateClusterTableCtrl);

  sgAreaStateClusterTableCtrl.$inject = ['Constants', 'Labels', 'SimpleDialogFormService', '$scope', 'sg2FloorAreaService',
    'sg2AreaService', '$injector'];

  function sgAreaStateClusterTableCtrl(Constants, Labels, SimpleDialogFormService, $scope, sg2FloorAreaService,
    sg2AreaService, $injector) {

    const vm = this;

    vm.$onInit = () => {
      vm.constants = Constants.getAll();
      vm.LABELS = Labels;

      setTimeout(() => {
        $scope.sg2AuthService = $injector.get('sg2AuthService');
      }, 100);
    };

    /**
    * Get total FNO for an area.
    *
    * @param area The area to calculate the FNO for.
    * @returns Total FNO for the area.
    */
    vm.getTotalFNO = (area) => {
      return sg2FloorAreaService.getAreaFNO(area);
    };

    vm.onDrop = (srcList, srcIndex, targetList, targetIndex) => {
      vm.dragAndDropCallback({
        srcList: srcList,
        srcIndex: srcIndex,
        targetList: targetList,
        targetIndex: targetIndex
      });
    };

    vm.callAddArea = (ev, clusterShortCode) => {
      vm.addArea({
        ev: ev,
        clusterShortCode: clusterShortCode
      });
    };

    /**
     * Broadcast the value from the Angular2 emitter to the proper controller.
     *
     * The Angular2 event emitter value seems to get lost by all the bindings, so
     * this workaround is needed. The receiving controller uses the already existing
     * AngularJS code for updating the area, so this emit is just a bridge between
     * the two controller.
     *
     * @todo Remove this workaround, and use the AreaStore.
     *
     * @param $event The data emitted by the Angular 2 code.
     * @param clusterId Cluster id.
     * @param buildingId Building id.
     * @param key The type of broadcast.
     */
    vm.submitAreaValueBroadcast = ($event, clusterId, buildingId, key): void => {
      $scope.$emit(`submitAreaValue`, $event, clusterId, buildingId, $event[key], key);
      // sg2AreaService.setFunctionality($event, key);
      // switch (key) {
      //   case 'functionality':
      //     sg2AreaService.setFunctionality($event, key);
      //     break;
      // }
    };

    // vm.setFunctionality = (area, functionality) => {
    //   sg2AreaService.setFunctionality($event, key);
    // };

    vm.getFunctionality = (id) => vm.constants.FUNCTIONALITIES.find((f) => f._id === id);

    vm.deleteAction = (area) => {
      const options = {
        title: Labels.getLabel('deletespecificationtitle'),
        content: Labels.getLabel('areyousuredeletespecification') + ' ' + Labels.getLabel('deletespecificationfromdatabase'),
        warning: Labels.getLabel('thisactioncannotbeundone')
      };
      SimpleDialogFormService.confirm(null, options)
        .then(() => vm.removeArea({area: area, cluster: vm.cluster, buildingId: vm.building._id})).catch(() => {
        });
    };

  }
})();
